import {Component, forwardRef, Input, SimpleChanges, ViewChild, ElementRef} from '@angular/core';
import { ControlContainer, DefaultValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HappyInputBase } from '../happy-template-input/happy-input-base';

export const TEXT_INPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => HappyTextInputComponent),
    multi: true,
};

@Component({
    selector: 'happy-text-input',
    templateUrl: './happy-text-input.component.html',
    styleUrls: ['./happy-text-input.component.css', '../styles.css'],
    viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
    providers: [TEXT_INPUT_VALUE_ACCESSOR]
})
export class HappyTextInputComponent extends HappyInputBase {

    @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;
    @ViewChild('el') private el: ElementRef;

    @Input() placeholder: string;
    @Input() value: string;
    @Input() dataHjSupress: boolean = false;
    @Input() type: string = 'text';
    @Input() autocomplete: string;
    @Input() autoFocus: boolean;

    constructor(parentForm: FormGroupDirective) {
        super(parentForm);
    }

    ngOnChanges(ch: SimpleChanges) {
        if (ch.value && ch.value.currentValue) {
            if (this.form && this.formControlName && this.form.get(this.formControlName)) {
                this.form.get(this.formControlName).setValue(ch.value.currentValue);
            }
        }
    }

    ngOnInit() {
        this.form = this.parentForm.form;
    }

    ngAfterViewInit(): void {
        if (this.autoFocus) {
            setTimeout(() => {
                this.el.nativeElement.focus();
            }, 20);
        }
    }
    writeValue(obj: any) {
        this.valueAccessor.writeValue(obj);
    }

    registerOnChange(fn: any) {
        this.valueAccessor.registerOnChange(fn);
    }

    registerOnTouched(fn: any) {
        this.valueAccessor.registerOnTouched(fn);
    }

    setDisabledState(isDisabled: boolean) {
        this.valueAccessor.setDisabledState(isDisabled);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-text-input/happy-text-input.component.ts